/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Bills_List_Col_AmountInputs */

const es_admin_billing_bills_list_col_amount = /** @type {(inputs: Admin_Billing_Bills_List_Col_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monto`)
};

const en_admin_billing_bills_list_col_amount = /** @type {(inputs: Admin_Billing_Bills_List_Col_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amount`)
};

/**
* | output |
* | --- |
* | "Amount" |
*
* @param {Admin_Billing_Bills_List_Col_AmountInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_bills_list_col_amount = /** @type {((inputs?: Admin_Billing_Bills_List_Col_AmountInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Bills_List_Col_AmountInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_bills_list_col_amount(inputs)
	return en_admin_billing_bills_list_col_amount(inputs)
});
export { admin_billing_bills_list_col_amount as "admin.billing.bills_list.col_amount" }